import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WarehouseCalendarService {

  constructor(private http: HttpClient) {}

  queryAllByFacilityAndCategory(facility: string, systemCategory: string): Observable<any>{
    var url = `${environment.logisticsApiUrl}/facilitycalendar/queryAllByFacilityAndCategory/${systemCategory}/${facility}`;
    return this.http.get(url);
  }

  updateCalendar(params: any): Observable<any>{
    var url = `${environment.logisticsApiUrl}/facilitycalendar/updateCalendar`;
    return this.http.put(url, params);
  }

  generateCalendar(params: any): Observable<any>{
    var url = `${environment.logisticsApiUrl}/facilitycalendar/generateCalendar`;
    return this.http.post(url, params);
  }

  copyCalendar(params: any): Observable<any>{
    var url = `${environment.logisticsApiUrl}/facilitycalendar/copyCalendar`;
    return this.http.post(url, params);
  }

  checkCalendarData(params: any): Observable<any>{
    var url = `${environment.logisticsApiUrl}/facilitycalendar/checkCalendarData`;
    return this.http.post(url, params);
  }
}
